import st from './Partners.module.scss'
import {useAppContext} from 'Context'

import logo1 from 'assets/images/law/1.png'
import logo2 from 'assets/images/law/2.png'
import logo3 from 'assets/images/law/3.png'
import logo4 from 'assets/images/law/4.png'
import useSWR from 'swr';
import axios from 'axios';


export const Partners = ()=> {
    const { region } = useAppContext()
    const { data } = useSWR('/region/logo?region_id='+region?.id, axios.get)
    const { partners, title, list, item, law, law_item  } = st

    return (
        <section className={partners}>
            <div className="wrapper">
                <h2 className={title}>ПРОЕКТ СОТРУДНИЧАЕТ</h2>

                {!!data?.data?.data?.length &&
                    <ul className={list}>
                        {data?.data?.data.map(partner => (
                            <a href={partner.url} className={item} key={partner.id} target="_blank" rel="noopener noreferrer">
                                <picture>
                                    <img src={partner.image.path} alt="" width={112} height={112} />
                                </picture>
                            </a>
                        ))}
                    </ul>
                }

                <ul className={law}>
                    <li className={law_item}>
                        <picture>
                            <img src={logo1} alt="" width={249} height={128} />
                        </picture>
                    </li>
                    <li className={law_item}>
                        <picture>
                            <img src={logo2} alt="" width={364} height={128} />
                        </picture>
                    </li>
                    <li className={law_item}>
                        <picture>
                            <img src={logo3} alt="" width={252} height={128} />
                        </picture>
                    </li>
                    <li className={law_item}>
                        <picture>
                            <img src={logo4} alt="" width={234} height={128} />
                        </picture>
                    </li>
                </ul>
            </div>
        </section>
    )
}
